// DashboardFooter.tsx — Sprint 14. The dark global footer with the
// CondoPro brand, support links, and version info. Pure
// presentation — no props.
import React from 'react';
import { Col, Layout, Row, Space, Typography } from 'antd';
import { HomeOutlined } from '@ant-design/icons';

const { Footer } = Layout;
const { Text } = Typography;

export const DashboardFooter: React.FC = () => (
  <Footer style={{ background: '#1a202c', padding: '24px 32px', borderTop: '1px solid #2d3748' }}>
    <Row justify="space-between" align="middle">
      <Col>
        <Space size="large">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{
              width: 24, height: 24,
              background: 'linear-gradient(135deg, #4299e1 0%, #3182ce 100%)',
              borderRadius: 6, marginRight: 12,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <HomeOutlined style={{ color: '#fff', fontSize: 12 }} />
            </div>
            <Text style={{ color: '#cbd5e0', fontSize: 14, fontWeight: 500 }}>
              CondoPro Management System
            </Text>
          </div>
          <Space size="middle">
            {/* Sprint 99 — placeholder footer links have no destination yet, so
                they render as link-styled <button>s (keyboard-accessible, no
                bogus href="#"). Wire real hrefs when these pages exist. */}
            {['Support', 'Documentation', 'API', 'Status'].map((label) => (
              <button
                key={label}
                type="button"
                style={{
                  color: '#a0aec0', fontSize: 13,
                  background: 'none', border: 'none', padding: 0,
                  cursor: 'pointer', font: 'inherit',
                }}
              >
                {label}
              </button>
            ))}
          </Space>
        </Space>
      </Col>
      <Col>
        <Space direction="vertical" size={2} align="end">
          <Text style={{ color: '#a0aec0', fontSize: 12 }}>Version 2.1.0 • Enterprise Edition</Text>
          {/* Sprint 35 — finding G12. Was hardcoded "© 2024 …" which
              read as stale every time someone opened the dashboard in
              a later year (current calendar is 2026). */}
          <Text style={{ color: '#718096', fontSize: 11 }}>
            © {new Date().getFullYear()} CondoPro Management Systems. All rights reserved.
          </Text>
        </Space>
      </Col>
    </Row>
  </Footer>
);
